<template>
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card >
        <v-card-title class="headline">Session Expired</v-card-title>
        <v-card-text>You have left this browser idle for 40 minutes</v-card-text>
    </v-card>
    </v-dialog>
</template>

<script>
export default {
	data() {
        
		return {
            time: 10000,
            dialog:true,
		}
	},
	created() {
    let timerId = setInterval(() => {
      this.time -= 1000;
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
      if (this.time < 1) {
        clearInterval(timerId);
       this.$firebase.auth.signOut().then(() => {
        this.$router.push("/login").catch((err) => {});
        this.$store.commit("setUser", null);
      });
        // Your logout function should be over here
        //alert('logout user....');
      }
    }, 1000);
  }
};
</script>

<style lang="postcss" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal {
  width: 500px;
  box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12);
  border-radius: 4px;
  @apply bg-white p-2;
}
.modal__title {
  color: #38404f;
  @apply flex items-center justify-between p-3 font-bold;
}
</style>